"use strict";

var getTokenPromise = null;
var makeMemoizedGetToken = function makeMemoizedGetToken(_ref) {
  var getToken = _ref.getToken;
  return function (options) {
    if (!getTokenPromise) {
      getTokenPromise = getToken(options);
    }
    return getTokenPromise.then(function (data) {
      getTokenPromise = null;
      return data;
    }).catch(function (err) {
      getTokenPromise = null;
      throw err;
    });
  };
};
module.exports = {
  makeMemoizedGetToken: makeMemoizedGetToken
};